import { FETCH_STATISTICS } from '../constants/history';

const initialState = {
  totalPurchases: 0,
  uniqueProducts: 0,
  purchaseFrequency: {
    itemsPerWeek: 0,
    itemsPerMonth: 0,
    tripsPerWeek: 0,
    tripsPerMonth: 0,
  },
  totalTrips: 0,
  shoppingHeatmap: [],
  abandonedProducts: [],
  abandonedProductsCount: 0,
  mostBoughtItems: [],
  monthlyPurchases: [],
  dayOfWeekStats: [],
  mostActiveDay: null,
  dateRange: {
    first: null,
    last: null,
  },
  productRestockPredictions: [],
  loading: true,
};

const history = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_STATISTICS:
      return {
        ...state,
        ...action.statistics,
        loading: false,
      };
    default:
      return state;
  }
};

export default history;
